import { render, staticRenderFns } from "./FilesTile.vue?vue&type=template&id=37fabee0&"
import script from "./FilesTile.vue?vue&type=script&lang=js&"
export * from "./FilesTile.vue?vue&type=script&lang=js&"
import style0 from "./FilesTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilesTile.vue"
export default component.exports